import React from 'react';
import './App.css';
import Chatbot from './components/Chatbot';
import HomePage from './components/HomePage'; // Assuming you have this component

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;

